<div *ngIf="open" class="slds-modal slds-fade-in-open">
    <div class="slds-modal__container">
        <div class="slds-modal__header">
            <button class="slds-button slds-button--icon-inverse slds-modal__close" type="button" (click)="close()">
                <svg class="slds-button__icon slds-button__icon--large" kdSldsIcon="close"></svg>
            </button>
            <h2 class="slds-text-heading--medium">{{heading}}</h2>
        </div>

        <div class="slds-modal__content slds-p-around--medium">
            <ng-content></ng-content>
        </div>
    </div>
</div>

<div *ngIf="open" class="slds-backdrop slds-backdrop--open"></div>
